import { Validators } from ".";
export var getAccountId = function(accountIdFromQuery) {
    var accountIdFromStorage = localStorage.getItem("vch.account_id");
    if (Validators.isString(accountIdFromQuery) && (accountIdFromQuery === null || accountIdFromQuery === void 0 ? void 0 : accountIdFromQuery.length)) {
        return accountIdFromQuery;
    } else if (accountIdFromStorage === null || accountIdFromStorage === void 0 ? void 0 : accountIdFromStorage.length) {
        return accountIdFromStorage;
    }
};

//# sourceMappingURL=get-account-id.js.map